import { ComponentDefinition } from '@contentful/experiences-sdk-react';

const externalVideoDefinition: ComponentDefinition = {
  id: 'externalVideo',
  name: 'External Video',
  category: 'Media',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/video.svg',
  variables: {
    sourceType: {
      displayName: 'Source',
      defaultValue: 'youtube',
      type: 'Text',
      validations: {
        in: [
          { value: 'youtube', displayName: 'YouTube' },
          { value: 'vimeo', displayName: 'Vimeo' },
          { value: 'directurl', displayName: 'Direct video URL' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    source: {
      displayName: 'Video ID/URL ',
      description:
        "If the video is hosted on YouTube or Vimeo please provide it's uniquie ID. Otherwise please provide direct video URL.",
      type: 'Text',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    borderRadius: {
      displayName: 'Rounded corners',
      type: 'Number',
      group: 'style',
      defaultValue: 8,
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    // roundedCorners: {
    //   displayName: 'Rounded corners',
    //   type: 'Text',
    //   group: 'style',
    //   defaultValue: 'Medium',
    //   validations: {
    //     in: [
    //       { value: '', displayName: 'None' },
    //       { value: 'xs', displayName: 'Small' },
    //       { value: 'md', displayName: 'Medium' },
    //       { value: 'lg', displayName: 'Large' },
    //       { value: 'xl', displayName: 'Extra large' },
    //     ],
    //     bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
    //   },
    // },
  },
};

export default externalVideoDefinition;
